module.exports = __webpack_public_path__ + "static/img/58_hands.9ae6937a.jpg";